import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ACTIVE_ASSAILANT,
  TRAIN_INCIDENT_ALERT_TYPE,
} from '@rsos/constants/alertTypes';
import {
  getNumUnreadAlertNotifications,
  StateWithIncidents,
} from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';
import { filteredAlertsSelector } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import Badge from '../Badge';
import styles from './AlertsBadge.module.scss';

type NotifyByAlertType =
  | typeof ACTIVE_ASSAILANT
  | typeof TRAIN_INCIDENT_ALERT_TYPE
  | null;

interface AlertsBadgeProps {
  notifyByAlertType?: NotifyByAlertType;
}

const AlertsBadge = ({ notifyByAlertType }: AlertsBadgeProps) => {
  const dispatch = useDispatch();
  const alerts = useSelector((state: StateWithIncidents) =>
    filteredAlertsSelector(state.incidents),
  );
  const { numUnreadAlertNotifications } = useSelector(
    (state: StateWithIncidents) => state.incidents,
  );
  const numTotalAlerts = Object.keys(alerts).length;
  const badgeClassName =
    notifyByAlertType === ACTIVE_ASSAILANT
      ? styles.badgeAssailant
      : notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE
        ? styles.badgeTrain
        : undefined;

  useEffect(() => {
    dispatch(getNumUnreadAlertNotifications());
  }, [alerts, dispatch]);

  return numUnreadAlertNotifications > 0 ? (
    <Badge counter={numUnreadAlertNotifications} className={badgeClassName} />
  ) : numTotalAlerts > 0 ? (
    // Since there is no background-color for TotalEvents, the color prop value is reversed.
    <span
      className={`${styles.totalEvents}${notifyByAlertType ? ` ${styles.totalEventsNotify}` : ''}`}
    >
      ({numTotalAlerts})
    </span>
  ) : null;
};

export default AlertsBadge;
